<template>
  <div class="stars" :class="{ withTotal: withCount }" v-if="stars">

    <span v-if="stars > 0">*</span>
    <span v-if="stars > 1">*</span>
    <span v-if="stars > 2">*</span>
    <span v-if="stars > 3">*</span>
    <span v-if="stars > 4">*</span>

    <!-- <img
      src="/img/icons/like.svg"
      v-svg-inline
      :class="{ inactive: stars < 1 ? true : false }"
    />
    <img
      src="/img/icons/like.svg"
      v-svg-inline
      :class="{ inactive: stars < 2 ? true : false }"
    />
    <img
      src="/img/icons/like.svg"
      v-svg-inline
      :class="{ inactive: stars < 3 ? true : false }"
    />
    <img
      src="/img/icons/like.svg"
      v-svg-inline
      :class="{ inactive: stars < 4 ? true : false }"
    />
    <img
      src="/img/icons/like.svg"
      v-svg-inline
      :class="{ inactive: stars < 5 ? true : false }"
    /> -->

    <span class="stars-total" v-if="withCount"> ({{ stars }}) </span>
  </div>
</template>

<script>
export default {
  props: ["withCount", "stars"],
};
</script>
